import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { isUploadInProgress, uploadItemAdapter } from '@reducers/uploads/uploads.reducer';
import { IUploadItem, UploadItem } from '@stylehaven/components';

import { ApplicationState, UploadItemState } from 'state';

export const getUploadItemState: MemoizedSelector<
    object,
    UploadItemState,
    DefaultProjectorFn<UploadItemState>
> = createFeatureSelector<UploadItemState>('uploadItem');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    uploadItemAdapter.getSelectors<ApplicationState>(getUploadItemState);

export const selectFeature = (state: ApplicationState) => state.uploadItem;

export const allUploadItemsSelector: MemoizedSelector<
    ApplicationState,
    UploadItem[],
    DefaultProjectorFn<UploadItem[]>
> = createSelector(selectAll, (items: IUploadItem[]) => items.map(item => new UploadItem(item)));

export const inProgressSelector: MemoizedSelector<
    ApplicationState,
    IUploadItem[],
    DefaultProjectorFn<IUploadItem[]>
> = createSelector(selectAll, (items: IUploadItem[]) => items.filter(isUploadInProgress));

export const inProgressCountSelector: MemoizedSelector<
    ApplicationState,
    number,
    DefaultProjectorFn<number>
> = createSelector(inProgressSelector, (items: IUploadItem[]) => items.length);

export const hasUploadsInProgressSelector: MemoizedSelector<
    ApplicationState,
    boolean,
    DefaultProjectorFn<boolean>
> = createSelector(inProgressSelector, (items: IUploadItem[]) => items.length > 0);

const reduceFunction = (acc: number, uploadItem: IUploadItem) => {
    const progress: number = uploadItem.state.progress || 0;
    return acc + progress;
};

export const totalUploadProgressSelector: MemoizedSelector<
    ApplicationState,
    number,
    DefaultProjectorFn<number>
> = createSelector(
    inProgressSelector,
    (items: IUploadItem[]) => Math.round(items.reduce(reduceFunction, 0) / items.length) || 0
);
